<template>
  <div>
        <validation-observer v-slot="{ invalid, valid, errors, ...rest }" ref="form">
          <form>
              <!--     AVAILABLE LICENSES       -->
              <validation-provider vid="license_id"  v-slot="{errors}">
                <c-select
                    v-show="license.available_licenses.length > 1"
                    @input="changeLicense(); $emit('change', form);"
                    valueKey="id"
                    labelKey="license"
                    :error="errors[0]"
                    :options="license.available_licenses"
                    v-model="form.licenseId"
                    label="Available Licenses"
                    :empty-option="true"
                    empty-option-label="- Select -"
                />
              </validation-provider>


              <validation-provider vid="state_id" :rules="'required'" v-slot="{errors}">
                <c-select
                    @input="$emit('change', form);"
                    valueKey="id"
                    labelKey="name"
                    :error="errors[0]"
                    :options="states"
                    v-model="form.stateId"
                    label="Licensure State"
                    :empty-option="true"
                    empty-option-label="- Select -"
                    required-mark="true"
                />
              </validation-provider>

              <validation-provider vid="discipline_id" :rules="disciplineIdRules" v-slot="{errors}">
                <c-select
                    @input="$emit('change', form);"
                    valueKey="id"
                    labelKey="label"
                    :error="errors[0]"
                    :options="license.available_disciplines"
                    v-model="form.disciplineId"
                    label="Professional Discipline"
                    :empty-option="true"
                    empty-option-label="- Select -"
                    required-mark="true"
                />
              </validation-provider>

              <validation-provider vid="discipline" :rules="disciplineRules" v-slot="{errors}">
                <c-input
                    :error="errors[0]"
                    v-model="form.discipline"
                    v-if="form.disciplineId == '0'"
                    label="Discipline"
                    required-mark="true"
                    @input="$emit('change', form)"
                />
              </validation-provider>

              <validation-provider vid="license" v-slot="{errors}">
                <c-input
                    :error="errors[0]"
                    v-model="form.license"
                    label="License Number/Code"
                    @input="$emit('change', form)"
                />
              </validation-provider>

          </form>
        </validation-observer>
      </div>
</template>

<script>
import stepper from "../ui/Stepper";
import licenseAPI from "../../api/licenseAPI";
import commonAPI from "../../api/commonAPI";
import Notify from "../ui/Notify";

export default {
  components: {
    stepper,
    Notify
  },
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      showIndicator: false,
      states: [],
      disciplines: [],
      license: {
        available_licenses: [],
        available_disciplines: [],
      },
      form: {
        licenseId: '',
        stateId: '',
        disciplineId: '',
        discipline: '',
        license: '',
      },

      // download certificate
      certificate: {},
      showCertificateButtonIndicator: false,
    }
  },
  computed: {
    disciplineRules() {
      return String(this.form.disciplineId) === '0' ? 'required' : '';
    },

    disciplineIdRules() {
      return 'required';
      // return String(this.form.disciplineId) !== '0' ? 'required' : '';
    }
  },
  watch: {
    // emit immediately and on any change (including programmatic assigns)
    form: {
      deep: true,
      immediate: true,
      handler(v) {
        this.$emit('change', v);
        // also emit "input" so parent can use v-model if desired
        this.$emit('input', v);
      }
    }
  },
  mounted() {
    this.fetch();
    this.fetchStates();
    this.fetchDisciplines();
  },
  methods: {
    downloadCertificate() {
      this.showCertificateButtonIndicator = true;

      licenseAPI.fetchCertificate(this.attendeeId)
        .then((res) => {
          this.certificate = res.data.data;
        })
        .catch(() => {})
        .finally(()=>{
          this.showCertificateButtonIndicator = false;
        });
    },

    fetchStates() {
      commonAPI.fetchStates()
        .then((res) => {
          this.states = res.data.data;
        });
    },

    fetchDisciplines() {
      commonAPI.fetchDisciplines()
        .then((res) => {
          this.disciplines = res.data.data;
        });
    },

    changeLicense() {
      const {
        id,
        state_id,
        discipline_id,
        discipline_other,
        license
      } = this.license.available_licenses.find(el => el.id == this.form.licenseId);

      this.form = {
        licenseId: this.form.licenseId,
        disciplineId: discipline_id,
        discipline: discipline_other,
        license: id ? license : '',
        stateId: state_id
      };
    },

    fetch() {
      this.isFetching = true;

      licenseAPI.fetch(this.attendeeId)
        .then((res) => {
          this.license = res.data;

          this.license.available_licenses.push({
            id: 0,
            license: 'Other',
            licenseId: '',
            disciplineId: '',
            discipline: '',
            stateId: ''
          });

          this.form = {
            licenseId: res.data.data.id,
            disciplineId: res.data.data.discipline_id,
            discipline: res.data.data.discipline_other,
            license: res.data.data.license,
            stateId: res.data.data.state_id
          };
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false;
        });
    },
    // submit() {
    //
    //   this.$refs.form.validate().then(success => {
    //     if (!success) {
    //       return;
    //     }
    //
    //
    //     this.showIndicator = true;
    //
    //     const {stateId, disciplineId, discipline, license, licenseId} = this.form
    //
    //
    //     let data = {
    //       state_id: stateId,
    //       discipline_id: disciplineId,
    //       license
    //     }
    //
    //     if (discipline) {
    //       data.discipline_other = discipline
    //     }
    //
    //     licenseAPI.send(this.attendeeId, data).then((res) => {
    //       this.activeStepIndex = 1;
    //
    //     }).catch((error) => {
    //
    //     }).finally(() => {
    //
    //       this.showIndicator = false;
    //
    //     })
    //
    //
    //     this.$nextTick(() => {
    //       this.$refs.form.reset();
    //     });
    //   })
    //
    // }
  },
}
</script>

<style lang="scss" scoped>
.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.license-info {
  h4 {
    margin-bottom: var(--attendee-gap-md);
  }
}
</style>
